<div class="relative z-[1] py-[60px] md:py-[80px] lg:py-[100px] xl:py-[150px]">
    <div class="container 2xl:max-w-[1320px] mx-auto px-[12px]">
        <!-- <div class="mx-auto text-center md:max-w-[650px] lg:max-w-[810px] xl:max-w-[785px] mb-[35px] md:mb-[50px] lg:mb-[65px] xl:mb-[90px]">

            <h2 class="!mb-0 !text-xl md:!text-2xl lg:!text-[34px] xl:!text-4xl -tracking-[.5px] md:-tracking-[.6px] lg:-tracking-[.8px] xl:-tracking-[1px] !leading-[1.2]">
                Un partenaire de confiance
            </h2>
        </div> -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[25px]">
            <div class="text-center ltr:lg:text-center rtl:lg:text-center">
                <div class="flex items-center justify-center w-[80px] h-[80px] md:w-[85px] md:h-[85px] rounded-[10px] md:rounded-[17px] mb-[20px] lg:mb-[22px] bg-gray-200 dark:bg-[#15203c] mx-auto">
                    <img src="images/front-pages/secure.svg" class="inline-block" alt="secure">
                </div>
                <h3 class="!text-lg md:!text-[20px] lg:!text-[22px] xl:!text-xl !mb-[10px] md:!mb-[12px] xl:!mb-[13px] !font-semibold !leading-[1.2]">
                     <!--i18n: Secure Payment -->
                     {{ 'i18n.app.features.pages.front-pages.common.fp-key-features.h3_01' | translate }}
                </h3>
                <p class="xl:max-w-[375px] !leading-[1.6] text-gray-400">
                    <!--i18n: Bank-grade security with encrypted transactions -->
                    {{ 'i18n.app.features.pages.front-pages.common.fp-key-features.p_01' | translate }}
                </p>
            </div>
            <div class="text-center ltr:lg:text-center rtl:lg:text-center">
                <div class="flex items-center justify-center w-[80px] h-[80px] md:w-[85px] md:h-[85px] rounded-[10px] md:rounded-[17px] mb-[20px] lg:mb-[22px] bg-primary-100 dark:bg-[#15203c] mx-auto">
                    <img src="images/front-pages/localisation.svg" class="inline-block" alt="localisation">
                </div>
                <h3 class="!text-lg md:!text-[20px] lg:!text-[22px] xl:!text-xl !mb-[10px] md:!mb-[12px] xl:!mb-[13px] !font-semibold !leading-[1.2]">
                    <!--i18n: Convenient Pickup -->
                    {{ 'i18n.app.features.pages.front-pages.common.fp-key-features.h3_02' | translate }}
                </h3>
                <p class="xl:max-w-[375px] !leading-[1.6] text-gray-400">
                    <!--i18n: Pick up at any of our branches across Belgium -->
                    {{ 'i18n.app.features.pages.front-pages.common.fp-key-features.p_02' | translate }}
                </p>
            </div>
            <div class="text-center ltr:lg:text-center rtl:lg:text-center">
                <div class="flex items-center justify-center w-[80px] h-[80px] md:w-[85px] md:h-[85px] rounded-[10px] md:rounded-[17px] mb-[20px] lg:mb-[22px] bg-primary-100 dark:bg-[#15203c] mx-auto">
                    <img src="images/front-pages/rate.svg" class="inline-block" alt="rate">
                </div>
                <h3 class="!text-lg md:!text-[20px] lg:!text-[22px] xl:!text-xl !mb-[10px] md:!mb-[12px] xl:!mb-[13px] !font-semibold !leading-[1.2]">
                    <!--i18n: Competitive Rates -->
                    {{ 'i18n.app.features.pages.front-pages.common.fp-key-features.h3_03' | translate }}
                </h3>
                <p class="xl:max-w-[375px] !leading-[1.6] text-gray-400">
                    <!--i18n: Live exchange rates updated in real-time -->
                    {{ 'i18n.app.features.pages.front-pages.common.fp-key-features.p_03' | translate }}
                </p>
            </div>
        </div>
    </div>
</div>